<template>  
  <modal v-model="show"
         :has-padding="false"
         max-width="700">         

    <button class="btn btn-primary btn-extra-round"
            :disabled="isGenerating"
            slot="activator">
      {{$t('message.admDataReport.message.generateReport')}}
    </button>

    <div>
      <AdminDataReportModalBody @started="hideModal" />
    </div>
  </modal>  
</template>

<script>
  import AdminDataReportModalBody from '@views/admin/data/components/report/AdminDataReportModalBody.vue'
  import Modal from "@/components/generic/Modal";
  import EventBus from '@packages/event-bus'

    export default {
        components: {
          AdminDataReportModalBody,
          Modal
        },

        data() {
            return {
              show: false,
              isGenerating: false
            }
        },

        mixins: [],

        methods: {
          closeModal() {
            this.show = false;
          },
          async getStatus() {
            const reportStatus = await this.$api.report.status();

            if(reportStatus) {
              this.isGenerating = true;
            }
          },
          hideModal() {
            this.isGenerating = true;
            this.show = false
          },
          setIsGeneratingFalse() {
            this.isGenerating = false;
          },
          setIsGeneratingTrue() {
            this.isGenerating = true;
          },
        },

        mounted() {
          this.getStatus()

          EventBus.$on('ADMIN_DATA_REPORT_END', this.setIsGeneratingFalse);
          EventBus.$on('ADMIN_DATA_REPORT_START', this.setIsGeneratingTrue);
        },

        beforeDestroy() {
          EventBus.$off('ADMIN_DATA_REPORT_END', this.setIsGeneratingFalse);
          EventBus.$off('ADMIN_DATA_REPORT_START', this.setIsGeneratingTrue);
        }
    }
</script>

<style lang="scss" scoped>
.admin-data-report-modal {
  ::v-deep .admin-data-report-modal-body {
    padding: 20px;

    h4 {
      text-align: center;
    }
  }
}

.btn {
  &:disabled {
    opacity: 0.6;
  }
}
</style>
